<template>
    <el-container height="100%">
        <td-permission :permissions="permissionsQuery">
            <div slot="havePermission">
                <el-aside class="aside-classify-tree">
                    <td-tree
                        :lazyloading="true"
                        @queryData="queryDeviceTreeData"
                        @querySearchData="queryDeviceSearchData"
                        :isDbClick="true"
                        :isClick="true"
                        :imgloading="true"
                        ref="TdDeviceTree"
                        :defaultProps="defaultProps"
                        :showBox="true"
                        @check="deviceCheck"
                        :checkStrictly="true"
                        :isDistributed="false"
                        :calInternal="false"
                        :isPaging="true"
                        :params="params"
                        :customProp="customProp"
                    >
                    </td-tree>
                </el-aside>
            </div>
        </td-permission>
        <el-container>
            <el-header class="alarm-device-classify-head" style="text-align: left;height: 80px;">
                <td-permission :permissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline">
                            <el-form-item :label="$t('common.ALARM_LEVEL')">
                                <td-select
                                    :options="alarmLevelList"
                                    @change="changeAlarmLevel"
                                    v-model="sAlarmLevelId"
                                    keys="sId"
                                    text="sName"
                                    :clearable="false"
                                    :placeholder="$t('common.PLEASE_SELECT')"
                                ></td-select>
                            </el-form-item>
                            <el-form-item class="paddingLeft10">
                                <td-button type="primary" :permissions="permissionsSave" :loading="classifyLoading" @click="btnAddDeviceClassify">{{ $t('common.SAVE') }}</td-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </td-permission>
            </el-header>
            <el-main>
                <td-permission :permissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-container style="height: 0px;top:80px">
                            <el-form :inline="true" class="demo-form-inline">
                                <el-form-item :label="$t('pgCommon.ALARM_TYPE_SELECT')">
                                    <td-button type="button" style="margin-left:20px;" @click="selectAll">{{ $t('common.CHECK_ALL') }}</td-button>
                                    <td-button type="button" @click="selectInvert">{{ $t('common.CHECK_INVERT') }}</td-button>
                                </el-form-item>
                            </el-form>
                        </el-container>
                        <div :style="'margin-top:70px;'">
                            <div v-show="this.alarmEventList.length == 0" style="margin-left: 45%;margin-top: 20%;">
                                <img :src="noDataImg" />
                            </div>
                            <td-checkbox-group
                                ref="alarmEventGroup"
                                v-model="checkedAlarmEventList"
                                checkboxStyle="width:210px"
                                :hasBtn="false"
                                :allList="alarmEventList"
                                keys="sId"
                                text="sName"
                            ></td-checkbox-group>
                        </div>
                    </div>
                </td-permission>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import api from './assets/api.js';
export default {
    created() {
        let that = this;
        window.addEventListener('resize', function() {
            that.width = window.innerWidth - 460;
        });
        this.initSelect();
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            formInline: {},
            triggerDeviceType: [],
            permissionsSave: ['alarmDeviceClassify:save'],
            permissionsQuery: ['alarmDeviceClassify:view'],
            editItem: '',
            noDataImg: require('./img/noTableData.png'),
            sAlarmLevelId: '',
            alarmLevelList: [],
            alarmEventList: [],
            checkedAlarmEventList: [],
            dialogEventVisible: false,
            dialogClassifyVisible: false,
            classifyLoading: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            queryDeviceTree: { query: '/device/queryDeviceOrgTree', search: '/device/queryDeviceOrgTreeByName' },
            params: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS
            },
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            customProp: ['noPermission'],
            width: window.innerWidth - 540
        };
    },
    // 方法的实现
    methods: {
        // 报警事件点击全选
        selectAll() {
            if (this.$refs.alarmEventGroup.allList.length != this.$refs.alarmEventGroup.currentValue.length) {
                this.$refs.alarmEventGroup.checkAllSet();
            }
        },
        // 报警事件点击反选
        selectInvert() {
            this.$refs.alarmEventGroup.counterSelection();
        },
        initSelect() {
            api.getAlarmLevel('{}', response => {
                if (response.data.content) {
                    this.alarmLevelList = response.data.content;
                    this.sAlarmLevelId = this.alarmLevelList[0].sId;
                }
            });
        },
        // 查询数据
        btnQuery() {},
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        eventDialogClose() {
            this.submit();
            this.dialogEventVisible = false;
        },
        classifyDialogClose() {
            this.dialogClassifyVisible = false;
        },
        // 报警级别改变执行的方法
        changeAlarmLevel() {
            this.getAlarmDeviceClassify();
        },
        // 保存设备分级
        btnAddDeviceClassify() {
            this.classifyLoading = true;
            let checkedEvent = this.$refs.alarmEventGroup.getCheckList();
            let checkedNode = this.$refs.TdDeviceTree.getCheckedNodes();
            let device = [];
            for (let i = 0; i < checkedNode.length; i++) {
                if (checkedNode[i].device) {
                    let deviceObj = {};
                    deviceObj.sId = checkedNode[i].sId;
                    deviceObj.deviceType = checkedNode[i].deviceType;
                    device.push(deviceObj);
                }
            }
            if (device.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE_NODE'), type: 'warning' });
                this.classifyLoading = false;
                return;
            }
            if (!this.alarmEventList || this.alarmEventList.length == 0) {
                this.$message({ showClose: true, message: this.$t('common.NOT_QUERY_ALARM_EVENT'), type: 'warning' });
                this.classifyLoading = false;
                return;
            }
            let allAlarmEvent = [];
            for (let j = 0; j < this.alarmEventList.length; j++) {
                allAlarmEvent.push(this.alarmEventList[j].sId);
            }
            let content = {};
            content.alarmDevice = device;
            content.levelId = this.sAlarmLevelId;
            content.checkAlarmEvent = checkedEvent;
            content.allAlarmEvent = allAlarmEvent;
            api.saveAlarmDeviceClassify(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/saveAlarmDeviceClassify', response.data.statusMessage);
                    this.classifyLoading = false;
                    return;
                }
                this.$message({ showClose: true, message: this.$t('common.SAVE_SUCCESS'), type: 'success' });
                this.classifyLoading = false;
            });
        },
        // 选中设备事件
        deviceCheck(data) {
            // 若点击设备
            if (data.device) {
                let deviceType = data.deviceType;
                let deviceTypeList = [];
                let checkedNode = this.$refs.TdDeviceTree.getCheckedNodes();
                if (checkedNode && checkedNode.length > 0) {
                    for (let i = 0; i < checkedNode.length; i++) {
                        if (deviceTypeList.indexOf(checkedNode[i].deviceType) < 0) {
                            deviceTypeList.push(checkedNode[i].deviceType);
                        }
                        if (checkedNode[i].deviceType === deviceType && checkedNode[i].sId !== data.sId) {
                            this.getAlarmDeviceClassify();
                            return;
                        }
                    }
                } else {
                    this.alarmEventList = [];
                    return;
                }
                api.getEventByDeviceType(JSON.stringify(deviceTypeList), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('alarm/getEventByDeviceType', response.data.statusMessage);
                        return;
                    }
                    this.alarmEventList = response.data.content;
                    this.getAlarmDeviceClassify();
                });
            }
        },
        // 查询设备分级信息
        getAlarmDeviceClassify() {
            let checkedNode = this.$refs.TdDeviceTree.getCheckedNodes();
            let device = [];
            for (let i = 0; i < checkedNode.length; i++) {
                if (checkedNode[i].device) {
                    device.push(checkedNode[i]);
                }
            }
            if (device.length > 0) {
                let content = {};
                content.alarmDevice = device;
                content.levelId = this.sAlarmLevelId;
                this.checkedAlarmEventList = [];
                api.getAlarmDeviceClassify(JSON.stringify(content), response => {
                    //防止二次回调
                    if (!response.data) {
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('alarm/getAlarmDeviceClassify', response.data.statusMessage);
                        return;
                    }
                    let deviceClassify = response.data.content;
                    let partChecked = deviceClassify.partChecked;
                    let allChecked = deviceClassify.allChecked;
                    this.checkedAlarmEventList = partChecked.concat(allChecked);
                });
            }
        },
        queryDeviceTreeData: function(item) {
            //查询报警设备类型
            if (this.triggerDeviceType.length == 0) {
                api.getDeviceTypeList('', response => {
                    let deviceType = response.data.content;
                    if (deviceType) {
                        for (let i = 0; i < deviceType.length; i++) {
                            this.triggerDeviceType.push(deviceType[i].iId);
                        }
                        this.deviceTreeData(item);
                    }
                });
            } else {
                this.deviceTreeData(item);
            }
        },
        //组织设备树
        deviceTreeData: function(item) {
            if (item.parentId === '' || item.parentId === null || item.parentId === undefined) {
                item.parentId = item.parentId = '';
            }
            let queryParam = {
                includeSelf: true, // 查询条件是否包含自己
                parentId: item.parentId,
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                noPermission: item.noPermission,
                deviceTypeList: this.triggerDeviceType,
                currentPage: item.currentPage,
                pageSize: item.pageSize
            };
            api.findDeviceTree(JSON.stringify(queryParam), response => {
                if (!response.data || !response.data.statusCode) {
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceOrgTree', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.$refs.TdDeviceTree.initData(response.data.content);
            });
        },
        queryDeviceSearchData: function(item) {
            //查询报警设备类型
            if (this.triggerDeviceType.length == 0) {
                api.getDeviceTypeList('', response => {
                    let deviceType = response.data.content;
                    if (deviceType) {
                        for (let i = 0; i < deviceType.length; i++) {
                            this.triggerDeviceType.push(deviceType[i].iId);
                        }
                        this.deviceSearchData(item);
                    }
                });
            } else {
                this.deviceSearchData(item);
            }
        },
        //组织设备树查询
        deviceSearchData: function(item) {
            let queryParam = {
                currentPage: item.currentPage,
                pageSize: item.pageSize,
                deviceTypeList: this.triggerDeviceType,
                caption: item.caption
            };
            api.queryDeviceOrgTreeByName(JSON.stringify(queryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceOrgTreeByName', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.$refs.TdDeviceTree.initData(response.data.content);
            });
        }
    }
};
</script>
<style scoped>
>>> .havePermitsClass {
    display: block !important;
}
</style>
